'use strict';

angular.module('programme')

.directive('block', function ()
{
    return {
        restrict: 'A',
        replace: true,
        templateUrl: 'modules/programme/editor-components/block/block.html',
        controller: 'BlockCtrl',
        controllerAs: '$ctrl',
    };
})

.controller('BlockCtrl', function ($scope)
{
    $scope.data.pull = $scope.data.pull || 'left';
    $scope.data.layout = $scope.data.layout || 'size1';
    $scope.data.image = $scope.data.image || [{type: 'image'}];
    $scope.data.showMore = $scope.data.showMore || false;
    $scope.data.showMoreLimit = $scope.data.showMoreLimit || 100;

    if ($scope.data.showDescription === undefined) {
        $scope.data.showDescription = true;
    }

    if ($scope.data.showTitle === undefined) {
        $scope.data.showTitle = true;
    }

    $scope.data.content = $scope.data.content || {
            title: 'TITLE HERE',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ac maximus quam. Praesent suscipit tincidunt ipsum,'
    };
});
